import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Zona horaria de Chile/Antofagasta
const TIMEZONE = 'America/Santiago';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('es-CL', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric',
    timeZone: TIMEZONE
  });
};

export const formatDateTime = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleString('es-CL', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: TIMEZONE
  });
};

export const formatDateShort = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('es-CL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: TIMEZONE
  });
};

export const formatTime = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleTimeString('es-CL', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: TIMEZONE
  });
};

export const formatDateISO = (date) => {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  // Convertir a zona horaria de Chile antes de obtener ISO
  return d.toLocaleDateString('en-CA', { timeZone: TIMEZONE });
};

export const getToday = () => {
  // Obtener fecha actual en zona horaria de Chile
  return new Date().toLocaleDateString('en-CA', { timeZone: TIMEZONE });
};

export const getNow = () => {
  // Obtener fecha y hora actual en zona horaria de Chile
  return new Date().toLocaleString('es-CL', { 
    timeZone: TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
};